var map = {
	"./Profile.js": "AL8v",
	"./Task.js": "X0Pi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sSIh";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules \.(js)$
// module id = sSIh
// module chunks = 1